import React, { useRef } from "react";
import { Modal, Button } from "react-bootstrap";
import style from "./history.module.scss";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import moment from "moment";
import { formatNumberWithCommasAndDecimal } from "../../helper";
import "./modalStyle.css";

const PointsHistoryModal = (props) => {
  console.log("propsmodal", props);
  const { currentTheme } = useSelector((state) => state.Theme);
  const Currency = useSelector((state) => state.curr);
  const { t } = useTranslation();
  const componentRef = useRef();
  console.log("Currency details ===", Currency);
  const adjustedTimestamp = moment
    .utc(props?.data?.data?.date)
    .subtract(8, "hours");
  const formattedDate = adjustedTimestamp
    .tz("Asia/Manila")
    .format("MM/DD/YYYY h:mm:ss A");
  return (
    <div style={{ display: "flex", justifyContent: "center" }}>
      <Modal
        show={props.show}
        // dialogClassName="modal-fullscreen"
        onHide={props.handleClose}
        contentClassName={`${
          currentTheme == "theme-dark"
            ? `${style.dark_mode_modalContent}`
            : `${style.modalContent}`
        }`}
        size="lg"
        // centered
      >
        <Modal.Header
          closeButton
          className={`${
            currentTheme == "theme-dark"
              ? `${style.dark_mode_modalHeader}`
              : `${style.modalHeader}`
          }`}
        ></Modal.Header>
        <Modal.Body
          style={{
            background: currentTheme === "theme-dark" ? "" : "#fff",
            maxWidth: "1000px !important",
            width: "100%",
            overflow: "scroll",
          }}
        >
          <div className={`${style.invoiceBody}`}>
            <div className={`${style.printButton}`}>
              <div style={{ display: "none" }}></div>
            </div>
            <Table responsive borderless width="900" height="100">
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div style={{ textAlign: "left" }}>
                  <h6>
                    <b>Sold TO</b>
                  </h6>
                  <p>
                    <b> {props?.data?.data?.name}</b>
                  </p>
                  <p>
                    <b>ADDRESS:</b> {props?.data?.data?.address}
                  </p>
                  <p>
                    <b>DELIVERY MODE:</b> {props?.data?.data?.deliveryMode}
                  </p>
                </div>
                <div style={{ width: "50%", textAlign: "right" }}>
                  <h3>Transaction No: {props?.data?.data?.transaction_no}</h3>
                  <p style={{ marginTop: 8 }}>
                    Transaction Date:
                    {formattedDate}
                  </p>
                </div>
              </div>
              <tbody>
                <tr>
                  <td colSpan="2">
                    <TableContainer style={{ marginTop: 12 }}>
                      <Table style={{ border: "none" }}>
                        <TableHead>
                          <TableRow>
                            <TableCell>
                              <b>Product Code</b>
                            </TableCell>
                            <TableCell>
                              <b>Product Name</b>
                            </TableCell>
                            <TableCell>
                              <b>Points Value</b>
                            </TableCell>
                            <TableCell>
                              <b>Quantity</b>
                            </TableCell>
                            <TableCell>
                              <b>Total</b>
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {props?.data?.data?.codeResult &&
                            props?.data.data?.codeResult.map(
                              (product, index) => (
                                <TableRow key={index}>
                                  <TableCell>{product.product_code}</TableCell>
                                  <TableCell>{product.product_name}</TableCell>
                                  <TableCell>{product.points_value}</TableCell>
                                  <TableCell>{product.quantity}</TableCell>
                                  <TableCell>
                                    {Currency.currentCurr +
                                      " " +
                                      formatNumberWithCommasAndDecimal(
                                        product.total * Currency.value,
                                        Currency.precision
                                      )}
                                  </TableCell>
                                </TableRow>
                              )
                            )}
                        </TableBody>
                      </Table>
                    </TableContainer>

                    <br />
                  </td>
                </tr>
                <tr>
                  <td colSpan="2">
                    <table
                      border="0"
                      width="50%"
                      height="100"
                      align="right"
                      className={style.tableBottom}
                    >
                      <TableRow>
                        <TableCell></TableCell>
                        <TableCell>Cart Totals</TableCell>
                      </TableRow>

                      <TableRow>
                        <TableCell>
                          <b>Cart Subtotal</b>
                        </TableCell>
                        <TableCell>
                          {props.data?.data?.sub_total
                            ? Currency.currentCurr +
                              " " +
                              formatNumberWithCommasAndDecimal(
                                props.data.data.sub_total * Currency.value,
                                Currency.precision
                              )
                            : Currency.currentCurr + " 0.00"}
                          {/* {props?.data?.data?.sub_total} */}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Shipping and handling</b>
                        </TableCell>
                        <TableCell>
                          {/* {props?.data?.data?.shipping} */}
                          {props.data?.data?.shipping
                            ? Currency.currentCurr +
                              " " +
                              formatNumberWithCommasAndDecimal(
                                props.data.data.shipping * Currency.value,
                                Currency.precision
                              )
                            : Currency.currentCurr + " 0.00"}
                        </TableCell>
                      </TableRow>
                      <TableRow style={{ backgroundColor: "lightgray" }}>
                        <TableCell>
                          <b>Discount</b>
                        </TableCell>
                        <TableCell>
                          {/* {props?.data?.data?.discount} */}
                          {props.data?.data?.discount
                            ? Currency.currentCurr +
                              " " +
                              formatNumberWithCommasAndDecimal(
                                props.data.data.discount * Currency.value,
                                Currency.precision
                              )
                            : Currency.currentCurr + " 0.00"}
                        </TableCell>
                      </TableRow>
                      <TableRow>
                        <TableCell>
                          <b>Order Total</b>
                        </TableCell>
                        <TableCell>
                          {/* {props?.data?.data?.order_total} */}
                          {props.data?.data?.order_total
                            ? Currency.currentCurr +
                              " " +
                              formatNumberWithCommasAndDecimal(
                                props.data.data.order_total * Currency.value,
                                Currency.precision
                              )
                            : Currency.currentCurr + " 0.00"}
                        </TableCell>
                      </TableRow>
                    </table>
                  </td>
                </tr>
              </tbody>
            </Table>
            {/* </div> */}
          </div>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="default" onClick={props.handleClose}>
            Close
          </Button>
        </Modal.Footer>
      </Modal>
    </div>
  );
};

export default PointsHistoryModal;
